module.exports = __webpack_public_path__ + "static/media/ic_save.7b687bf2.svg";